export const GET_RELEASE_NOTES_DATA = 'GET_RELEASE_NOTES_DATA'
export const SET_RELEASE_NOTES_RESPONSE = 'SET_RELEASE_NOTES_RESPONSE'
